import registerEffects from "./register-effects.js";

const effect = {
	registerEffects: registerEffects,
};

export default effect;
